<app-modal [body]="privacyNotice" [options]="modalOptions"></app-modal>

<ng-template #privacyNotice>
  <div [innerHtml]="sanitizer.bypassSecurityTrustHtml(privacyNoticeText)"></div>
</ng-template>
